import { Relationship } from '@models/relationships/relationship';
import { SecurityType } from './security-type';
import { SecurityHoldingValidationError } from "./security-holding-validation-error";
import { Guid } from "@shared/utils/guid.helper";

export class SecurityHolding {
  securityHoldingId: string;
  securityTypeId: string;
  securityHoldingAsicId: string;
  entityId: string;
  number: number;
  previousNumber?: number;
  paid: number;
  unpaid: number;
  securityType: SecurityType;
  fullyPaid: boolean;
  isPosted: boolean;
  relationships: Relationship[] | null = null;
  validationErrors: SecurityHoldingValidationError[];

  // group by options
  hash: string;
  hashWithType: string;
  hashWithClass: string;

  constructor(data: Partial<SecurityHolding> = {}) {
    this.securityHoldingId = data.securityHoldingId ?? '';
    this.securityTypeId = data.securityTypeId ?? '';
    this.securityHoldingAsicId = data.securityHoldingAsicId || Guid.EmptyGuid;
    this.entityId = data.entityId ?? '';
    this.number = data.number ?? 0;
    this.previousNumber = data.previousNumber ?? 0;
    this.paid = data.paid ?? 0;
    this.unpaid = data.unpaid ?? 0;
    this.securityType = new SecurityType(data.securityType) ?? new SecurityType();
    this.fullyPaid = data.fullyPaid ?? false;
    this.isPosted = data.isPosted ?? false;
    this.relationships = data.relationships?.map(r => new Relationship(r)) ?? null;
    this.validationErrors = data.validationErrors?.map((error) => SecurityHoldingValidationError.createSecurityHoldingValidationError(error)) ?? [];

    this.hash = data.hash ?? '';
    this.hashWithType = data.hashWithType ?? '';
    this.hashWithClass = data.hashWithClass ?? '';
  }
}
